import React from 'react';

import { SPEC_COURSE_LESSON_VIEW_TABS } from 'common.components/spec-course-lesson-view/typings';

import { SpecCourseLessonViewResultsTabContent } from '../__results-tab-content/lesson-view__results-tab-content';
import { SpecCourseLessonViewRulesTabContent } from '../__rules-tab-content/lesson-view__rules-tab-content';
import { SpecCourseLessonViewDiagnosticsResults } from '../__diagnostics-result/lesson-view__diagnostics-result';

interface Props {
    tabSlug: string;
    awardsRef: React.RefObject<HTMLDivElement>;
    resultsRef: React.RefObject<HTMLDivElement>;
}

export const SpecCourseLessonViewTabContent = ({ awardsRef, tabSlug, resultsRef }: Props) => {
    switch (tabSlug) {
        case SPEC_COURSE_LESSON_VIEW_TABS.RULES:
            return <SpecCourseLessonViewRulesTabContent />;

        case SPEC_COURSE_LESSON_VIEW_TABS.RESULTS:
            return <SpecCourseLessonViewResultsTabContent awardsRef={awardsRef} resultsRef={resultsRef} />;

        case SPEC_COURSE_LESSON_VIEW_TABS.DIAGNOSTICS_RESULTS:
            return <SpecCourseLessonViewDiagnosticsResults />;

        default:
            return null;
    }
};
